import { useCallback } from 'react';

import { CumulativeGrades } from 'applications/GSP/entities/CumulativeGrades';
import { UpcomingAssignments } from 'applications/GSP/pages/Dashboard/components/UpcomingAssignments';
import { AnalyticsEvent } from 'applications/GSP/shared/constants/analytics';
import {
  useAnalytics,
  useAnalyticsSessionDuration,
} from 'applications/GSP/shared/hooks/analytics';
import { FeatureFlagGuard } from 'shared/components/guards/FeatureFlagGuard';
import { FlexibleWrapper } from 'shared/components/wrappers/FlexibleWrapper';

import { LatestGrades } from './components/LatestGrades';
import { Wrapper } from './components/Wrapper';
import { useGetDashboard } from './hooks';

export const Dashboard = () => {
  const { data, isLoading } = useGetDashboard();
  const analytics = useAnalytics();

  useAnalyticsSessionDuration(AnalyticsEvent.DashboardSessionDuration);

  const onInteract = useCallback(() => {
    analytics.track(AnalyticsEvent.DashboardCumulativeGradesChartBarClicked);
  }, [analytics]);

  return (
    <Wrapper>
      <FlexibleWrapper
        sx={{
          flexBasis: theme => ({
            xs: '100%',
            lg: `calc(50% - ${theme.spacing(3)})`,
          }),
        }}
      >
        <UpcomingAssignments />
      </FlexibleWrapper>
      <FlexibleWrapper
        sx={{
          flexBasis: theme => ({
            xs: '100%',
            lg: `calc(50% - ${theme.spacing(3)})`,
          }),
        }}
      >
        <LatestGrades />
      </FlexibleWrapper>
      <FeatureFlagGuard featureKey="hideCumulativeGrades">
        <FlexibleWrapper>
          <CumulativeGrades
            isLoading={isLoading}
            data={data?.subjectGradesChart}
            onInteract={onInteract}
          />
        </FlexibleWrapper>
      </FeatureFlagGuard>
    </Wrapper>
  );
};
